import { render, staticRenderFns } from "./processItem.vue?vue&type=template&id=35be8120&scoped=true&"
import script from "./processItem.vue?vue&type=script&lang=js&"
export * from "./processItem.vue?vue&type=script&lang=js&"
import style0 from "./processItem.vue?vue&type=style&index=0&id=35be8120&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35be8120",
  null
  
)

export default component.exports